/* eslint-disable no-restricted-syntax */
import { all, call, put, takeLatest, takeLeading, } from 'redux-saga/effects';

import * as apicore from "services/core";
import * as type from './constant';
import * as action from './action';

function* getListItems({ params, selfRole }) {
  try {

    const data = [];
    let p = 0;
    let tp = 0;
    do {
      const { results, page, totalPages } = yield call(apicore.getMemberRequest, { ...params, page: p + 1, limit: 50 }, selfRole);
      data.push(...results)
      p = page;
      tp = totalPages;
    } while (p < tp);
    yield put(action.getMemberSuccess(data, selfRole));

  } catch (error) {
    yield put(action.getMemberError(error?.response?.data?.message || error?.response?.statusText || error.toString()));
  }
}

function* addItem({ payload, selfRole }) {
  try {

    const response = yield call(apicore.addMemberRequest, payload, selfRole);
    yield put(action.addMemberSuccess(response));

  } catch (error) {
    yield put(action.manipulationMemberError(error?.response?.data?.message || error?.response?.statusText || error.toString()));
  }
}

function* updateItem({ id, payload, selfRole }) {
  try {

    const response = yield call(apicore.updateMemberRequest, id, payload, selfRole);
    yield put(action.updateMemberSuccess(response));

  } catch (error) {
    yield put(action.manipulationMemberError(error?.response?.data?.message || error?.response?.statusText || error.toString()));
  }
}

function* deleteItem({ ids, selfRole }) {
  try {

    for (const id of ids) {
      yield call(apicore.deleteMemberRequest, id, selfRole);
    }
    
    yield put(action.deleteMemberSuccess(true));

  } catch (error) {
    yield put(action.manipulationMemberError(error?.response?.data?.message || error?.response?.statusText || error.toString()));
  }
}

function* updateSelfItem({ id, payload }) {
  try {

    const response = yield call(apicore.updateMemberSelfRequest, id, payload);
    yield put(action.updateMemberSelfSuccess(response));

  } catch (error) {
    yield put(action.manipulationMemberError(error?.response?.data?.message || error?.response?.statusText || error.toString()));
  }
}

function* getOverview({ id, params, selfRole }) {
  try {

    const response = yield call(apicore.getMemberOverviewRequest, id, params, selfRole);
    yield put(action.getMemberOverviewSuccess(response, selfRole));

  } catch (error) {
    yield put(action.manipulationMemberError(error?.response?.data?.message || error?.response?.statusText || error.toString()));
  }
}

export function* watchGetList() {
  yield takeLatest(type.GET, getListItems);
}
export function* watchAddList() {
  yield takeLeading(type.ADD, addItem);
}
export function* watchUpdateItem() {
  yield takeLeading(type.UPDATE, updateItem);
}
export function* watchDeleteItem() {
  yield takeLeading(type.DELETE, deleteItem);
}
export function* watchUpdateSelfItem() {
  yield takeLeading(type.UPDATE_SELF, updateSelfItem);
}
export function* watchOverview() {
  yield takeLeading(type.GET_OVERVIEW, getOverview);
}

export default function* rootSaga() {
  yield all([
    watchGetList(),
    watchUpdateItem(),
    watchAddList(),
    watchDeleteItem(),
    watchOverview(),
  ]);
}
